import styled from 'styled-components';
import { Space, Text } from '@cashfree-intl/coherent';

export const StyledDivider = styled.div`
  background: #e6e5e8;
  height: 1px;
`;

export const StyledSmallText = styled(Text)`
  margin-top: 0.75rem;
`;

export const StyledBankDetails = styled.div`
  border-radius: 0.25rem;
  background: #f9f5ff;
  padding-bottom: 0.25rem;
`;

export const StyledBankDetailsRow = styled(Space)`
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
`;

export const StyledNoteSection = styled.div`
  border-radius: 0.125rem;
  background: rgba(214, 131, 9, 0.12);
  padding: 0.75rem 1rem;
  li {
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1rem;
  }
`;

export const StyledInsufficientAmountFooter = styled.div`
  padding: 1rem 1.5rem;
  border-radius: 0px 0px 0.5rem 0.5rem;
  background: #e6e9ee;
`;

export const StyledModalText = styled(Text)`
  margin-top: 0.75rem;
`;

export const StyledModalContent = styled.div`
  border-radius: 0.5rem;
  background: #fbf3e6;
  .link-button {
    min-width: fit-content;
  }
`;

export const TooltipContent = styled.div`
  width: 19.75rem;
  .divider {
    border: 1px solid var(--TABLE_COLUMN);
  }
`;
